import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link, useNavigate } from 'react-router-dom';
import { Zoom } from 'react-reveal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelopeOpen, faLock } from '@fortawesome/free-solid-svg-icons';
import swal from 'sweetalert';

const Login = () => {
    const { register, handleSubmit, reset, formState: { errors } } = useForm();
    const [customError, setCustomError] = useState('');
    const navigate = useNavigate();


    //Register From 
    const onSubmit = data => {
        fetch('https://one0m-backend2.onrender.com/auth/login', {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
                authorization: `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify(data)
        })
            .then(res => res.json())
            .then(result => {
                if (result?.success) {
                    swal('Login Successfully', 'Your account login successfully done', 'success');
                    localStorage.setItem('token', result?.token);
                    setCustomError('');
                    navigate('/');
                    reset();
                }
                if (result?.message) {
                    setCustomError(result?.message)
                }
            })
    }

    return (
        <div className='container-fluid p-5' style={{ marginTop: '100px', fontFamily: 'Poppins' }}>
            <Zoom>
                <div className="register-account">
                    <div className="row">
                        <div className="col-lg-4 mx-auto cBorder shadow-lg pt-3 pb-3">
                            <div className="loginTitle text-center mb-3">
                                <h4 className='fw-bold'>Login Now!!</h4>
                            </div>
                            {/* Custom Error  */}

                            <p className='text-light text-center bg-danger mb-3 rounded'>{customError}</p>

                            <form onSubmit={handleSubmit(onSubmit)}>

                                <div className="row gy-2">
                                    <div className="col-lg-12">
                                        <div class="input-group mb-2">
                                            <span className="input-group-text btn btn-danger border border-danger" id="basic-addon1"><FontAwesomeIcon icon={faEnvelopeOpen} className='text-light' /></span>
                                            <input {...register("email", { required: true })} className='form-control' placeholder='Email address' type='email' />
                                        </div>
                                        {errors.email && <span className='text-danger'>Email is required</span>}
                                    </div>
                                    <div className="col-lg-12">
                                        <div class="input-group mb-2">
                                            <span className="input-group-text btn btn-danger border border-danger" id="basic-addon1"><FontAwesomeIcon icon={faLock} className='text-light' /></span>
                                            <input {...register("password", { required: true })} className='form-control' placeholder='Your password' type='password' />
                                        </div>
                                        {errors.password && <span className='text-danger'>Password is required</span>}
                                    </div>
                                    <div className="col-lg-12">
                                        <input type="submit" className='d-block btn btn-danger w-100 border-0 text-light fw-bold rounded p-2' value='Login' />
                                    </div>
                                </div>
                            </form>
                            <p className='mt-4 text-secondary text-center' style={{ fontFamily: 'Poppins' }}>No account yet ?  <Link to='/register' className='fs-6 fw-bold'>Register</Link></p>
                        </div>
                    </div>

                </div>
            </Zoom>
        </div>
    );
};
export default Login;